module.exports = __webpack_public_path__ + "img/1.be2da9c3.png";